import * as tslib_1 from "tslib";
import { Component, Prop } from "vue-property-decorator";
import SmartOrg from "./smart-org/smartOrg.vue";
import { StaffSelectorBase } from "../staff-selector-base";
let StaffSelector = class StaffSelector extends StaffSelectorBase {
    get SearchPlaceholder() {
        let output = "";
        if (this.options.selectOrg) {
            // output = "搜索组织";
            output = 'SearchOrg';
        }
        if (this.options.selectUser) {
            // output = "搜索姓名/账号";
            output = 'SearchNameAccount';
        }
        if (this.options.selectOrg && this.options.selectUser) {
            // output = "搜索组织、姓名";
            output = 'SearchOrgUserRole';
        }
        return output;
    }
    treeFocus() {
        super.treeFocus();
    }
    // 树-返回
    onClickTrunBack() {
        super.onClickTrunBack();
    }
    // 树-下一级
    onClickNextHierarchy(val) {
        super.onClickNextHierarchy(val);
    }
    onClickBreadcrumb(val) {
        super.onClickBreadcrumb(val);
    }
    onChange(items) {
        super.onChange(items);
    }
    onOk(items) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            _super("onOk").call(this, items);
        });
    }
    onCancle() {
        super.onCancle();
    }
    onSearch(name) {
        let type = "";
        if (this.options.selectOrg) { //选组织
            type = 'department';
        }
        if (this.options.selectUser) { //选人
            type = 'user';
        }
        if (this.options.selectOrg && this.options.selectUser) { //选组织/人
            type = "";
        }
        super.onSearch(name, type);
    }
};
tslib_1.__decorate([
    Prop()
], StaffSelector.prototype, "visiblePart", void 0);
StaffSelector = tslib_1.__decorate([
    Component({
        name: "staff-selector",
        components: {
            SmartOrg,
        },
        model: {
            event: "change",
            prop: "value",
        },
    })
], StaffSelector);
export default StaffSelector;
